import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

export class SelectUnitproxyApply extends Component {
  static displayName = SelectUnitproxyApply.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [],
      local_net_id: '',
      local_unit_id: '',
      current_user_type: localStorage.getItem('login_user_type'),
      parentName: props.parentName,
    };
  }


  componentDidMount() {
    this.loadData(this.props.selectnet, this.props.local_net_name);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectnet !== this.props.selectnet || prevProps.local_net_name !== this.props.local_net_name) {
      this.loadData();
    }
  }

  loadData() {
    let apiUrl = api_url + this.state.requiredAPI;
    let { parentName } = this.props;
    const formData = new FormData();
    if (parentName === 'superS') {
      formData.append("local_net_id", this.props.selectnet);
      formData.append("local_net_name", this.props.local_net_name);
    } else if (parentName === 'superM') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
    }


    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => {
        // console.log("Fetch Response: ", response);
        return response.json();
      })
      .then(data => {
        // console.log(data)
        let arr_status = [String(data.statusCode), data.row, data.detail]; //api 回傳判斷
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ options: rows }, () => {
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedName = event.target.options[selectedIndex].text;
    this.props.SelectUnitproxyApply({ name, value, selectedName });
  };

  render() {
    return (
      <Input
        id={this.state.id}
        name={this.state.name}
        onChange={this.handleSelectChange}
        type='select'
        value={this.props.selectedName} // 使用 prop 設置選擇的值
      >
        <option value="">請選擇</option>
        {this.state.options.map((option, index) => (
          <option key={`${option.local_unit_id}-${index}`} value={option.local_unit_id}>
            {option.local_unit_name}
          </option>
        ))}

      </Input>
    );
  }
}